<template>
    <div class="pt-2 pb-6 md:py-6">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 class="text-2xl font-semibold text-gray-900">
                <SmartBreadcrumbs
                    type="InertiaLink"
                    :pages="[
                        {
                            name: $tc('messages.fouls', 1),
                            href: meta.links.index,
                        },
                        {
                            name: student.full_name,
                            href: null,
                        },
                    ]"
                />
            </h1>
        </div>

        <div class="max-w-7xl mx-auto">
            <div class="pt-2 pb-6 md:py-6">
                <div class="max-w-7xl mx-auto md:px-4 sm:px-6 md:px-8">
                    <div class="md:grid md:grid-cols-3 md:gap-6">
                        <div class="md:col-span-1">
                            <div class="bg-white overflow-hidden sm:rounded-lg sm:shadow">
                                <img
                                    :src="student.avatar_or_default"
                                    alt="photo"
                                    class="mx-auto rounded-full h-32 w-32 border-4 border-white"
                                />

                                <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                                    <div class="flex flex-col justify-center items-center">
                                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                                            {{ student.first_name }}
                                        </h3>
                                        <h3 class="leading-6 font-base text-gray-600">
                                            {{ $t('messages.student') }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 py-5 bg-white sm:p-6">
                                    <div class="md:grid md:grid-cols-6 md:gap-6">
                                        <div class="sm:col-span-2">
                                            <label
                                                for="subject_id"
                                                class="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                {{ $tc('messages.subjects', 1) }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.subject_name }}
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <label for="date" class="block text-sm font-medium leading-5 text-gray-700">
                                                {{ $t('messages.date') }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.date_display }}
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <label for="time" class="block text-sm font-medium leading-5 text-gray-700">
                                                {{ $t('messages.time') }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.time }}
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <label class="block text-sm font-medium leading-5 text-gray-700">
                                                {{ $t('messages.turn') }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.turn_display }}
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <label for="type" class="block text-sm font-medium leading-5 text-gray-700">
                                                {{ $t('messages.type') }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.type_display }}
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <label
                                                for="severity"
                                                class="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                {{ $t('messages.severity') }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.severity_display }}
                                            </div>
                                        </div>

                                        <div class="sm:col-span-6">
                                            <label
                                                for="description"
                                                class="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                {{ $t('messages.description') }}
                                            </label>
                                            <div class="mt-1">
                                                <p class="whitespace-pre-line">{{ foul.public_description }}</p>
                                            </div>
                                        </div>

                                        <div class="sm:col-span-2">
                                            <label
                                                for="severity"
                                                class="block text-sm font-medium leading-5 text-gray-700"
                                            >
                                                {{ $tc('messages.teachers', 1) }}
                                            </label>
                                            <div class="mt-1">
                                                {{ foul.teacher_name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'foul', 'student', 'options', 'counters'],
    data() {
        return {};
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
